// import { useMemo } from 'react';

// material-ui
import { Box, Button, Stack, useMediaQuery } from "@mui/material";

import AnimateButton from "components/@extended/AnimateButton";
import DrawerHeader from "layout/MainLayout/Drawer/DrawerHeader";
import { Link } from "react-router-dom";
// import Lottie from "lottie-react";
import { MenuOrientation } from "config";
// import MobileSection from "./MobileSection";
// import Localization from './Localization';
import Notification from "./Notification";
// import Message from './Message';
import Profile from "./Profile";
import PurchaseBundle from "./PurchaseBundle";
import { ShoppingCart } from "iconsax-react";
import { get } from "lodash";
// import christmasbounce from "assets/video/christmas-bounce.json";
import { makeStyles } from "@material-ui/styles";
// import PurchaseBundleIcon from "./PurchaseBundleIcon";
// import PurchaseBundle from './PurchaseBundle';
// project-imports
// import Search from './Search';
import useConfig from "hooks/useConfig";
import { useGetSubClients } from "hooks/queries/usermanagement";
import useUserAuthInfo from "hooks/useAuthInfo";

// import MegaMenuSection from './MegaMenuSection';

// ==============================|| HEADER - CONTENT ||============================== //

const useStyles = makeStyles(() => ({
  pulseButton: {
    animation: `$pulseAnimation 0.8s infinite`
  },
  "@keyframes pulseAnimation": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
      boxShadow: `0 0 0 0 #196377`
    },
    "70%": {
      transform: "scale(1)",
      opacity: 0.7,
      boxShadow: "0 0 0 10px rgba(255, 0, 0, 0)"
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
      boxShadow: " 0 0 0 0 rgba(255, 0, 0, 0)"
    }
  }
}));

const HeaderContent = () => {
  const { menuOrientation } = useConfig();
  const { userType } = useUserAuthInfo();
  const classes = useStyles();
  const { token, clientid } = useUserAuthInfo();

  const getSUbClients = useGetSubClients(200, clientid);
  const clientSubClients = get(getSUbClients, "data.data.content");

  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const localization = useMemo(() => <Localization />, [i18n]);

  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}

      {userType === "ADMIN" || userType === "STAFF" ? (
        !downLG && <Box sx={{ width: "100%", ml: { xs: 0, md: 2 } }} />
      ) : (
        <Box sx={{ width: "100%", ml: { xs: 0, md: 2 } }}>
          <Stack direction="row" spacing={2}>
            <PurchaseBundle title="Prepaid Credit" clientSubClients={clientSubClients} token={token} clientid={clientid} />
            <Link to="/credits/bundles">
              <AnimateButton>
                <Button
                  className={classes.pulseButton}
                  fullWidth
                  sx={{
                    fontSize: {
                      xs: 10,
                      md: 14
                    }
                  }}
                  color="primary"
                  variant="contained"
                  startIcon={<ShoppingCart />}
                >
                  Buy Bundle
                </Button>
              </AnimateButton>
            </Link>
          </Stack>

          {/* {downLG && (
            <Stack direction="row" alignItems="center">
              <PurchaseBundleIcon />
              <Link to="/credits/bundles">
                <IconButton
                  color="primary"
                  variant="light"
                  aria-label="purchase bundle"
                  aria-haspopup="true"
                  size="large"
                  sx={{ color: "secondary.main" }}
                >
                  <MirroringScreen variant="Bold" />
                </IconButton>
                <Typography color="black">Purchase Bundle</Typography>
              </Link>
            </Stack>
          )} */}
        </Box>
      )}

      {/* {!downLG && megaMenu}
      {!downLG && localization} */}
      {/* {downLG && <Box sx={{ width: '100%', ml: 1 }} />} */}
      {/* {downLG && (
        <Box sx={{}}>
          <Lottie animationData={christmasbounce} loop={true} />
        </Box>
      )} */}

      <Notification />

      {/* <Message /> */}
      <Profile />
      {/* {downLG && <MobileSection />} */}
    </>
  );
};

export default HeaderContent;
